import { render, staticRenderFns } from "./PromotionBanner.vue?vue&type=template&id=fe278be2&scoped=true&"
import script from "./PromotionBanner.vue?vue&type=script&lang=js&"
export * from "./PromotionBanner.vue?vue&type=script&lang=js&"
import style0 from "./PromotionBanner.vue?vue&type=style&index=0&id=fe278be2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe278be2",
  null
  
)

export default component.exports